import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getCompanyThemeAsync, updateCompanyThemeAsync } from './companyThemeThunk';
const initialState = {
    status: APIStatus.IDLE,
    currentTheme: null,
    isThemeApplied: false
};
export const companyThemeSlice = createSlice({
    name: 'companyTheme',
    initialState,
    reducers: {
        clearTheme(state) {
            state.currentTheme = null;
            state.isThemeApplied = false;
            state.apiError = undefined;
        },
        setThemeApplied(state, action) {
            state.isThemeApplied = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            // Get Company Theme
            .addCase(getCompanyThemeAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCompanyThemeAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.currentTheme = action.payload;
            state.isThemeApplied = false; // Theme needs to be applied after fetching
        })
            .addCase(getCompanyThemeAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
            state.currentTheme = null;
        })
            // Update Company Theme
            .addCase(updateCompanyThemeAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateCompanyThemeAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.currentTheme = action.payload;
            state.isThemeApplied = false; // Theme needs to be reapplied after update
        })
            .addCase(updateCompanyThemeAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearTheme, setThemeApplied } = companyThemeSlice.actions;
export default companyThemeSlice.reducer;
